import React from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'

export const UsageSlider = () => {

    return (
        <Carousel autoPlay={true} centerSlidePercentage={90} showIndicators={false} infiniteLoop={true} showStatus={false} transitionTime={1000} stopOnHover={true} showThumbs={false}>
            <div className="df jcc">
                <div className="card">
                    <img src="./img/quality/privacy-policy.png" alt="privacy-policy" className="slide_icon" />
                    <div>Privacy</div>
                </div>
                <div className="card">
                    <img src="./img/quality/safety.png" alt="safety" className="slide_icon" />
                    <div>Safety</div>
                </div>
                <div className="card">
                    <img src="./img/quality/support.png" alt="support" className="slide_icon" />
                    <div>Support</div>
                </div>
                <div className="card">
                    <img src="./img/quality/equipment.png" alt="equipment" className="slide_icon" />
                    <div>Equipment</div>
                </div>
                <div className="card">
                    <img src="./img/quality/warranty.png" alt="warranty" className="slide_icon" />
                    <div>Warranty</div>
                </div>
            </div>
        </Carousel>
    )
}


